export const MAX_ROUNDS_PRACTICE = 2;
export const MAX_ROUNDS_TRIAL = 12;
export const ROUND_START_MIN_DIGITS = 3;
export const ROUND_MIN_DIGITS = 2;
export const DIGIT_CYCLE_INTERVAL_TIME = 525;
export const DIGIT_CYCLE_START_DELAY = 225;
